import React from 'react';
import HeroSection from '../components/landing/HeroSection';
import CertificationBadge from '../components/landing/CertificationBadge';
import ProblemSolutionSection from '../components/landing/ProblemSolutionSection';
import ValuePropositionSection from '../components/landing/ValuePropositionSection';
import CapabilitiesSection from '../components/landing/CapabilitiesSection';
import EconomicsSection from '../components/landing/EconomicsSection';
import TargetAudienceSection from '../components/landing/TargetAudienceSection';
import ProcessSection from '../components/landing/ProcessSection';
import LeadFormSection from '../components/landing/LeadFormSection';
import Footer from '../components/landing/Footer';
import Header from '../components/landing/Header';
import FloatingContactButton from '../components/landing/FloatingContactButton';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white text-slate-800">
      <Header />
      <main>
        <HeroSection />
        <CertificationBadge />
        <ProblemSolutionSection />
        <ValuePropositionSection />
        <CapabilitiesSection />
        <EconomicsSection />
        <TargetAudienceSection />
        <ProcessSection />
        <LeadFormSection />
        <CertificationBadge />
      </main>
      <Footer />
      <FloatingContactButton />
    </div>
  );
};

export default LandingPage;
